import { put, fork, call, takeEvery, all, select } from 'redux-saga/effects';
import app from '../../app';
import {
  createSslCompletion,
  loadSslHelpListCompletion,
  loadSslDetailWithProductCodeCompletion,
  loadSslDetailWithGameIdCompletion,
} from '../../actions';

export function* watchCreateSsl() {
  yield takeEvery('CREATE_SSL', function*({ code, inviteGameId }) {
    const shareUid = yield select(state => state.own.shareUid);
    const options = {
      url: '/api/ssl/game/create',
      method: 'POST',
      data: { code, refUid: shareUid, gameId: inviteGameId },
    };
    const result = yield call(app.httpFetch, options);
    yield put(createSslCompletion(result.error, result.data, inviteGameId));
  });
}

export function* watchLoadSslDetailWithProdcutCode() {
  yield takeEvery('LOAD_SSL_DETAIL_WITH_PRODUCT_CODE', function*({
    productCode,
  }) {
    const options = {
      url: `/api/ssl/act/${productCode}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadSslDetailWithProductCodeCompletion(
        productCode,
        result.error,
        result.data
      )
    );
  });
}

export function* watchLoadSslHelpList() {
  yield takeEvery('LOAD_SSL_HELP_LIST', function*({ gameId }) {
    const options = {
      url: `/api/ssl/gameUser/${gameId}?start=0&size=1000`,
    };

    const result = yield call(app.httpFetch, options);
    yield put(
      loadSslHelpListCompletion(
        gameId,
        result.error,
        result.data && result.data.listData,
        result.data && result.data.count
      )
    );
  });
}

export function* watchLoadSslDetailWithGameId() {
  yield takeEvery('LOAD_SSL_DETAIL_WITH_GAME_ID', function*({ gameId }) {
    const options = {
      url: '/api/ssl/act/invite',
      data: { gameId },
    };

    const result = yield call(app.httpFetch, options);
    yield put(
      loadSslDetailWithGameIdCompletion(gameId, result.error, result.data)
    );
  });
}

export default function* sslSaga() {
  yield all([
    fork(watchCreateSsl),
    fork(watchLoadSslHelpList),
    fork(watchLoadSslDetailWithProdcutCode),
    fork(watchLoadSslDetailWithGameId),
  ]);
}
